import React from 'react';
export const furnishings = [
  ['bed', 'Giường', 'Bed'], ['mattress', 'Nệm', 'Mattress'], ['wardrobe', 'Tủ quần áo', 'Wardrobe'],
  ['desk', 'Bàn ghế', 'Table & chairs'], ['air_conditioner', 'Máy lạnh', 'Air conditioner'],
  ['fridge', 'Tủ lạnh', 'Refrigerator'], ['water_heater', 'Máy nước nóng', 'Water heater'],
  ['kitchen', 'Bếp', 'Kitchen'], ['washing_machine', 'Máy giặt', 'Washing machine'], ['curtains', 'Rèm cửa', 'Curtains'],
];
export const furnishingDefaults = (details = {}) => ({
  furnishing: details.furnishing || 'custom',
  furnishings: details.furnishing === 'full' ? furnishings.map(([key]) => key) : [...(details.furnishings || [])],
});
export default function ProjectFurnishings({ value, onChange, disabled, en }) {
  const selected = value.furnishings || [];
  return <div className="project-amenities">
    {[['full', 'Full'], ['empty', en ? 'Unfurnished' : 'Trống']].map(([mode, label]) => <label key={mode}><input type="checkbox" disabled={disabled} checked={value.furnishing === mode} onChange={(event) => onChange({ furnishing: event.target.checked ? mode : 'custom', furnishings: event.target.checked ? (mode === 'full' ? furnishings.map(([key]) => key) : []) : selected })} /><span>{label}</span></label>)}
    {furnishings.map(([key, vi, english]) => <label key={key}><input type="checkbox" disabled={disabled} checked={selected.includes(key)} onChange={(event) => {
      const next = event.target.checked ? [...selected, key] : selected.filter((item) => item !== key);
      onChange({ furnishings: next, furnishing: next.length === furnishings.length ? 'full' : 'custom' });
    }} /><span>{en ? english : vi}</span></label>)}
  </div>;
}
